import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
  SVG_Add_Square_Bold,
  SVG_Traffic_Bold,
  SVG_Trash_Bin_2_Bold,
  SVG_Trash_Bin_2_Linear,
  SVG_Trash_Bin_2_Outline,
  SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
const AgeRestrictions = ({ tab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goBack = useCustomNavigate(tab);
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const handleDeleteTag = tag => {
    const updatedTags = tags.filter(t => t !== tag);
    setTags(updatedTags);
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      if (inputValue.trim() !== '') {
        setTags([...tags, inputValue.trim()]);
        setInputValue(' ');
      }
    }
  };

  const getAgeRestrictions = async () => {
    const response = await CreateAction({
      method: 'get',
      path: `/agerestrictions`,
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) {
      return navigate('/dashboard/');
    }

    setTags(response?.result?.resultData || []);
  };
  const saveAgeRestrictions = async () => {
    const response = await CreateAction({
      method: 'patch',
      path: `/agerestrictions`,
      showPreLoader: true,
      isFileUploading: false,
      data: { ageRestrictions: tags },
    });
    if (response.error) return;
    goBack();
  };

  const predefinedTags = ['deneme', 'deneme 2', 'deneme 3'];

  const handlePredefinedTagClick = tag => {
    if (!tags.includes(tag)) {
      setTags([...tags, tag]);
    }
  };

  useEffect(() => {
    getAgeRestrictions();
  }, []);
  return (
    <>
      <LayeredDashboardHeader tab={tab} onSave={saveAgeRestrictions}></LayeredDashboardHeader>
      <div className="w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto">
            <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]">
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="text-[#5E5873] text-[18px] font-semibold">Ayarlar</div>
                </div>

                <div className="mt-[40px]">
                  <div className="text-[#5E5873] block mb-[5px] text-[14px] font-semibold">+18 Kategor Filtresi </div>
                  <div className="text-[#8A92A6] block mb-[5px] text-[14px] font-medium">
                    +18 filigramı görünmesi gereken kategorilerinizin içerdiği kelimeleri yazınız (virgülle ayrılır)
                  </div>

                  <div className="mb-[15px]">
                    <div className="text-[#5E5873] block mb-[5px] text-[14px] font-semibold">Örnek Kategoriler</div>
                    <div className="flex items-center gap-[10px] ">
                      {predefinedTags.map((predefinedTag, index) => (
                        <div
                          key={index}
                          className="cursor-pointer inline-block mr-[5px] mt-[5px] rounded-[5px] tag bg-[#F8F8F8] text-[#8A92A6] text-[13px] font-medium px-[8px] py-[4px]"
                          onClick={() => handlePredefinedTagClick(predefinedTag)}
                        >
                          {predefinedTag}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <MyInput
                      classes={'py-[30px] px-[25px]'}
                      value={inputValue}
                      onChange={value => setInputValue(value)}
                      onKeyDown={handleKeyPress}
                      placeholder="Etiket giriniz"
                      type="text"
                    />
                    {tags.map((tag, index) => (
                      <div
                        key={index}
                        className="inline-block mr-[15px] mt-[15px] rounded-[5px] tag bg-[#F8F8F8] text-[#8A92A6] text-[13px] font-medium px-[8px] py-[4px]"
                      >
                        <div className="flex items-center gap-[10px]">
                          <span>{tag}</span>
                          <img className="cursor-pointer" src={deleteX} onClick={() => handleDeleteTag(tag)} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgeRestrictions;
